import React from "react"
import Banner from "../component/sections/Banner"
import Intro from "../component/sections/Intro"
import Highlights from "../component/sections/Highlights"
import FeedbackInvitation from "../component/sections/FeedbackInvitation"

const HomePage = () => {
  return (
    <>
      <Banner />
      <Intro />
      <Highlights />
      <FeedbackInvitation />
    </>
  )
}

export default HomePage
